import React, { HTMLAttributes } from 'react';

// types
import { Follower } from 'ducks/merchantDucks/agency/types';
import { PaymentMethod } from 'ducks/merchantDucks/paymentMethods/types';
import { ModalNames } from 'ducks/merchantDucks/modal/types';

// actions
import { UpdateFollowerPayload } from 'ducks/merchantDucks/agency/actions';

// components
import BaseModal, { ModalActions } from 'components/Modals/BaseModal';
import { OptionsType, OptionTypeBase } from 'react-select';
import CreateUpdateClientForm from '../forms/CreateUpdateClientForm';
import UpdateExistingMerchantModal from './UpdateExistingMerchantModal';

interface OwnProps {
  scopeOptions: OptionsType<OptionTypeBase>;
  isFetching: boolean;
  handleCreateUpdateClient: (data: UpdateFollowerPayload) => any;
  paymentMethods: Array<PaymentMethod>;
  followerMethods: Array<PaymentMethod>;
  follower: Partial<Follower>;
  editMode: boolean;
  noMethods: boolean;
  addMerchantMode?: boolean;
}

type Props = OwnProps & HTMLAttributes<HTMLDivElement>;

const ClientModal = (props: Props) => {
  const {
    className,
    scopeOptions,
    isFetching,
    handleCreateUpdateClient,
    paymentMethods,
    followerMethods,
    follower,
    editMode,
    noMethods,
    addMerchantMode = false,
  } = props;

  let label = '';
  if (addMerchantMode) {
    label = 'Update existing merchant';
  } else {
    label = editMode ? 'Manage inheritance' : 'Create a new related account';
  }

  return (
    <BaseModal
      className={className}
      title={label}
      type="client"
      modalName={ModalNames.Client}
      render={({ closeModal }: ModalActions) =>
        addMerchantMode ? (
          <UpdateExistingMerchantModal
            addMerchantMode={addMerchantMode}
            scopeOptions={scopeOptions}
            isFetching={isFetching}
            handleCloseModal={closeModal}
            onSubmit={handleCreateUpdateClient}
            paymentMethods={paymentMethods}
            followerMethods={followerMethods}
            isMethodsFetching={isFetching}
            follower={follower}
            editMode={editMode}
            noMethods={noMethods}
          />
        ) : (
          <CreateUpdateClientForm
            scopeOptions={scopeOptions}
            isFetching={isFetching}
            handleCloseModal={closeModal}
            onSubmit={handleCreateUpdateClient}
            paymentMethods={paymentMethods}
            followerMethods={followerMethods}
            isMethodsFetching={isFetching}
            follower={follower}
            editMode={editMode}
            noMethods={noMethods}
          />
        )
      }
    />
  );
};

export default ClientModal;
